/**
 * Search results form — scope dropdown + (results-page only) facet filtering.
 *
 * Scope dropdown: redirects to external URLs for events/catalog/arstudies.
 * Runs wherever #search-results-form exists (search results page, 404, etc.).
 *
 * Facet filters: client-side show/hide of results by post type. Only binds on
 * the search results page itself.
 */

// ---------------------------------------------------------------------------
// Scope dropdown — redirect to external search on submit
// ---------------------------------------------------------------------------

const form = document.getElementById("search-results-form");
const scope = document.getElementById("search-scope");
const input = document.getElementById("search-results-input");

if (form && scope && input) {
  form.addEventListener("submit", (e) => {
    const query = input.value.trim();
    if (!query) return;

    const selected = scope.value;

    if (selected === "events") {
      e.preventDefault();
      const location = form.dataset.eventsLocation || "";
      window.open(
        buildEventsUrl(query, location),
        "_blank",
        "noopener,noreferrer",
      );
    } else if (selected === "catalog") {
      e.preventDefault();
      window.open(buildCatalogUrl(query), "_blank", "noopener,noreferrer");
    } else if (selected === "arstudies") {
      e.preventDefault();
      window.open(buildArstudiesUrl(query), "_blank", "noopener,noreferrer");
    }
    // "website" → native form submit
  });
}

function buildEventsUrl(query, location) {
  const today = new Date();
  const start = formatDate(today);
  const end = `${today.getFullYear() + 1}-12-31`;
  const params = new URLSearchParams({ term: query });
  if (location) params.set("l", location);
  params.set("r", "range");
  params.set("start", start);
  params.set("end", end);
  return `https://events.cals.org/events?${params.toString()}`;
}

function buildCatalogUrl(query) {
  const params = new URLSearchParams({ query, searchType: "smart" });
  return `https://cals.bibliocommons.com/v2/search?${params.toString()}`;
}

function buildArstudiesUrl(query) {
  return `https://arstudies.contentdm.oclc.org/digital/search/searchterm/${encodeURIComponent(query)}`;
}

function formatDate(d) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

// ---------------------------------------------------------------------------
// Facet filtering — client-side show/hide (search results page only)
// ---------------------------------------------------------------------------

if (document.querySelector(".search-results")) {
  const facets = document.querySelectorAll(".search-facets .filter-bar-btn");
  const results = document.querySelectorAll(".search-result");
  const noResults = document.getElementById("search-no-results");

  facets.forEach((btn) => {
    btn.addEventListener("click", () => {
      const facet = btn.dataset.facet;

      // Update active state
      facets.forEach((f) => {
        f.setAttribute("aria-pressed", f === btn ? "true" : "false");
      });

      // Filter results
      let visibleCount = 0;
      results.forEach((result) => {
        const show = !facet || result.dataset.postType === facet;
        result.hidden = !show;
        if (show) visibleCount++;
      });

      if (noResults) {
        noResults.hidden = visibleCount > 0;
      }
    });
  });
}
